import React, { Component } from 'react';

import { View, StyleSheet } from 'react-native';
import { Search } from '@mui/icons-material'

import SearchInput from '../searchInput';
import Colors from '../../config/Colors';
import Layout from '../../config/Layout';

export default class SearchButton extends Component {
    state = {
        query: ''
    };

    render() {
        const config = {
            query: this.state.query,
            title: 'Produto ou código de barras',
            onChange: (q) => this.onChange(q),
            onClean: () => this.onClean()
        };

        return (
            <View style={styles.container}>
                <Search name="search" 
                sx={{
                    fontSize: 20,
                    color: Colors.greyDark
                  }} 
                />

                <SearchInput {...config} style={styles.content} />
            </View>
        );
    }

    onChange = (query) => {
        this.changeSearchValue(query);
        this.setState({ ...this.state, query });
    };

    onClean = (query) => {
        this.changeSearchValue(query);
        this.setState({ ...this.state, query: '' });
    };

    changeSearchValue = (query) => {
        const { searchChange } = this.props;
        clearTimeout(this.time);
        this.time = setTimeout(() => {
            searchChange(query);
        }, 400);
    };
}

const styles = StyleSheet.create({
    container: {
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row',
        backgroundColor: Colors.white,
        paddingHorizontal: 12,
        borderRadius: 5,
        borderWidth: 1,
        borderColor: Colors.border
    },
    content: {
        flex: 1,
        marginLeft: Layout.gutterMedium
    }
});
